import {Component} from "@angular/core";

@Component({
  selector: 'administration-component',
  templateUrl: './administration.component.html',
  host: { 'class': 'page' }
})
export class AdministrationPageComponent {

  constructor() {
  }
}




// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/administration/administration.component.ts